import './GenreList.css';
import React, { useEffect, useState } from 'react';

export function GenreList(props) {
    const {genres, genreCounts} = props;
    const [numPages, setNumPages] = useState();
    const pageSize = 10;

    useEffect(() => {
        setNumPages(Math.ceil(genres.length / 10));
    }, [genres]);

    /**
     * Used to create a list of div elements that each contain
     * up to 10 genres to display to the user. The genres are taken
     * from the list of genres passed as a prop and the pages are 
     * created based on the numPages state variable.
     * @returns Array of divs each representing a page of
     * at most 10 genres.
     */
    function createPages() {
        let pages = [];
        for (let i = 0; i < numPages; i++) {
            pages.push(genres.slice(i * pageSize, i * pageSize + pageSize));
        }
        return pages.map((page, i) => {
            return (
                <div className='genre-page'>    
                    {page.map((genre, j) => {
                        return (
                            <div className='genre-result' key={j}>
                                <span>{genreCounts[genre]} {genre}</span>
                            </div>
                        );
                    })}
                </div>
            )
        });
    }

    return (
        <div className='GenreList'>
            {/* <ul>
                <li>{numPages} pages</li>
                {genres.map((entry, i) => {
                    return <li key={i}>{genreCounts[entry]} {entry}</li>
                })}
            </ul> */}
            <div className='genre-carousel'>
                {createPages()}
            </div>    
        </div>
    );
}